var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 900,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okText: this.$store.getters.language["common.okButton"],
        "ok-disabled": _vm.disableSubmit,
        okButtonProps: { props: { disabled: _vm.disabled } },
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "titile",
                            label: _vm.language["announcement.header"]
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["announcement.mustHeader"],
                              maxLength: 99,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.titile,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "titile", $$v)
                              },
                              expression: "model.titile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "msgCategory",
                            label: _vm.language["announcement.msgCategory"]
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["announcement.msgCategory"],
                                disabled: _vm.disableSubmit,
                                getPopupContainer: function(target) {
                                  return target.parentNode
                                }
                              },
                              on: { change: _vm.categoryChange },
                              model: {
                                value: _vm.model.msgCategory,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "msgCategory", $$v)
                                },
                                expression: "model.msgCategory"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.language["announcement.notification"]
                                  )
                                )
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.language["announcement.systemMessages"]
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "startTime",
                            label: _vm.language["common.beginTime"] + ":"
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              getCalendarContainer: function(node) {
                                return node.parentNode
                              },
                              disabled: _vm.disableSubmit,
                              placeholder:
                                _vm.language["common.choosebeginTime"],
                              showTime: "",
                              dateFormat: "YYYY-MM-DD HH:mm:ss"
                            },
                            on: { change: _vm.startTimeChange },
                            model: {
                              value: _vm.model.startTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "startTime", $$v)
                              },
                              expression: "model.startTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "endTime",
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "endTime",
                            label: _vm.language["common.endTime"]
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              getCalendarContainer: function(node) {
                                return node.parentNode
                              },
                              disabled: _vm.disableSubmit,
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["common.endTime"],
                              showTime: "",
                              dateFormat: "YYYY-MM-DD HH:mm:ss"
                            },
                            on: { change: _vm.endTimeChange },
                            model: {
                              value: _vm.model.endTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "endTime", $$v)
                              },
                              expression: "model.endTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: _vm.language["announcement.priority"]
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["announcement.priority"],
                                disabled: _vm.disableSubmit,
                                getPopupContainer: function(target) {
                                  return target.parentNode
                                }
                              },
                              model: {
                                value: _vm.model.priority,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "priority", $$v)
                                },
                                expression: "model.priority"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "L" } }, [
                                _vm._v(_vm._s(_vm.language["common.low"]))
                              ]),
                              _c("a-select-option", { attrs: { value: "M" } }, [
                                _vm._v(_vm._s(_vm.language["common.middle"]))
                              ]),
                              _c("a-select-option", { attrs: { value: "H" } }, [
                                _vm._v(_vm._s(_vm.language["common.high"]))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: _vm.language["system.announcement.needReply"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              "trigger-change": true,
                              disabled: _vm.disableSubmit,
                              dictCode: "platform_anno_need_reply"
                            },
                            model: {
                              value: _vm.model.needReply,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "needReply", $$v)
                              },
                              expression: "model.needReply"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label:
                              _vm.language["system.announcement.needSendMail"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              "trigger-change": true,
                              disabled: _vm.disableSubmit,
                              dictCode: "platform_anno_need_send_mail"
                            },
                            on: { change: _vm.needSendMailChange },
                            model: {
                              value: _vm.model.needSendMail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "needSendMail", $$v)
                              },
                              expression: "model.needSendMail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.model.needSendMail == 1
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label:
                                  _vm.language[
                                    "system.announcement.isSendMailNow"
                                  ]
                              }
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: { disabled: _vm.disableSubmit },
                                  model: {
                                    value: _vm.isSendMailNowValue,
                                    callback: function($$v) {
                                      _vm.isSendMailNowValue = $$v
                                    },
                                    expression: "isSendMailNowValue"
                                  }
                                },
                                [
                                  _c("a-radio", { attrs: { value: "0" } }, [
                                    _vm._v(_vm._s(_vm.language["common.no"]))
                                  ]),
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v(_vm._s(_vm.language["common.yes"]))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationId",
                            label: _vm.language["application"]
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              allowClear: "",
                              getPopupContainer: function(target) {
                                return target.parentNode
                              },
                              options: _vm.applicationOptions,
                              disabled: _vm.disableSubmit
                                ? _vm.disableSubmit
                                : _vm.$store.getters.application
                                    .applicationType !== "platform",
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["application"]
                            },
                            on: { change: _vm.applicationChange },
                            model: {
                              value: _vm.model.applicationId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationId", $$v)
                              },
                              expression: "model.applicationId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 24 } }),
                  _vm.showLaborPart
                    ? _c(
                        "span",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 / 2 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "laborAnnounceCategory",
                                    label:
                                      _vm.language[
                                        "system.labor.notice.category"
                                      ]
                                  }
                                },
                                [
                                  _c("j-dict-select-tag", {
                                    attrs: {
                                      dictCode: "labor_announce_category",
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language[
                                          "system.labor.notice.category"
                                        ],
                                      disabled: _vm.disableSubmit
                                    },
                                    model: {
                                      value: _vm.model.laborAnnounceCategory,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "laborAnnounceCategory",
                                          $$v
                                        )
                                      },
                                      expression: "model.laborAnnounceCategory"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 / 2 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "laborAnnounceEntity",
                                    label:
                                      _vm.language["system.labor.notice.object"]
                                  }
                                },
                                [
                                  _c("j-dict-select-tag", {
                                    attrs: {
                                      dictCode: "labor_announce_entity",
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language[
                                          "system.labor.notice.object"
                                        ],
                                      disabled: _vm.disableSubmit
                                    },
                                    model: {
                                      value: _vm.model.laborAnnounceEntity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "laborAnnounceEntity",
                                          $$v
                                        )
                                      },
                                      expression: "model.laborAnnounceEntity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 / 2 } },
                    [
                      _vm.secondMsgCategoryShow
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: this.$store.getters.language[
                                  "announcement.secondMsgCategory"
                                ]
                              }
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    allowClear: "",
                                    disabled: _vm.disableSubmit,
                                    getPopupContainer: function(target) {
                                      return target.parentNode
                                    }
                                  },
                                  model: {
                                    value: _vm.secondMsgCategoryValue,
                                    callback: function($$v) {
                                      _vm.secondMsgCategoryValue = $$v
                                    },
                                    expression: "secondMsgCategoryValue"
                                  }
                                },
                                _vm._l(_vm.secondMsgCategorylist, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "a-select-option",
                                    { key: index, attrs: { value: item.code } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.model.applicationId
                ? _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _vm.model.applicationId
                            ? _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "msgType",
                                    label: _vm.language["announcement.msgType"]
                                  }
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder:
                                          _vm.language["common.pleaseChoose"] +
                                          _vm.language["announcement.msgType"],
                                        disabled: _vm.disableSubmit
                                      },
                                      on: { change: _vm.chooseMsgType },
                                      model: {
                                        value: _vm.model.msgType,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "msgType", $$v)
                                        },
                                        expression: "model.msgType"
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "USER" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "announcement.appointUser"
                                              ]
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "APPLICATION" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "announcement.allUser"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _vm.model.msgType === "USER"
                            ? _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label:
                                      _vm.language["announcement.appointUser"],
                                    prop: "validateSelectedUser"
                                  }
                                },
                                [
                                  _c("a-select", {
                                    attrs: {
                                      mode: "multiple",
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language["user"],
                                      labelInValue: true,
                                      disabled: _vm.disableSubmit
                                    },
                                    on: {
                                      dropdownVisibleChange: _vm.selectUserIds,
                                      change: _vm.handleChange
                                    },
                                    model: {
                                      value: _vm.selectedUser,
                                      callback: function($$v) {
                                        _vm.selectedUser = $$v
                                      },
                                      expression: "selectedUser"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelColX1,
                            wrapperCol: _vm.wrapperColX1,
                            prop: "msgAbstract",
                            label: _vm.language["announcement.msgAbstract"]
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["announcement.msgAbstract"],
                              disabled: _vm.disableSubmit,
                              maxLength: 20000
                            },
                            model: {
                              value: _vm.model.msgAbstract,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "msgAbstract", $$v)
                              },
                              expression: "model.msgAbstract"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "j-field-content",
                          attrs: {
                            labelCol: _vm.labelColX1,
                            wrapperCol: _vm.wrapperColX1,
                            label: _vm.language["announcement.msgContent"]
                          }
                        },
                        [
                          _c("j-editor", {
                            attrs: { disabled: _vm.disableSubmit },
                            model: {
                              value: _vm.model.msgContent,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "msgContent", $$v)
                              },
                              expression: "model.msgContent"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.uploadSource
                ? _c(
                    "a-tab-pane",
                    {
                      key: _vm.refKeys[0],
                      attrs: {
                        tab: _vm.language["selfCheck.ref.file"],
                        forceRender: true
                      }
                    },
                    [
                      _c("j-editable-table", {
                        ref: _vm.refKeys[0],
                        attrs: {
                          uploadSource: _vm.uploadSource,
                          loading: _vm.announcementFileTable.loading,
                          columns: _vm.announcementFileTable.columns,
                          dataSource: _vm.announcementFileTable.dataSource,
                          maxHeight: 300,
                          maxNumber: 10000,
                          disabled: _vm.disableSubmit
                            ? _vm.disableSubmit
                            : _vm.formDisabled,
                          rowNumber: true,
                          "is-show-download-button": false,
                          rowSelection: true,
                          actionButton: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("select-user-list-modal", {
        ref: "UserListModal",
        on: { choseUser: _vm.choseUser }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }